export const useAuth = () => {
    return sessionStorage.getItem('adminId');
};
